import { Component, Input } from '@angular/core';
import { ParkingEventDTO } from '@lkp/parking-sdk';
import { DateService } from 'src/app/core/services/date.service';

@Component({
    selector: 'app-entry-exit',
    templateUrl: './entry-exit.component.html',
    styleUrls: ['./entry-exit.component.scss'],
    standalone: false
})
export class EntryExitComponent {
  @Input() parkingEvents?: ParkingEventDTO[] = [];
  displayedColumns = [
    'eventDate',
    'user',
    'parkingDevice',
    'parkingEventType',
    'scanType',
  ];

  constructor(readonly dateService: DateService) {}

  formatDate(date: string | Date): string {
    return this.dateService.formatDate(date);
  }
  formatTime(date: string | Date): string {
    return this.dateService.formatTime(date);
  }
}
